import { HttpErrorResponse } from '@angular/common/http';

import { CropField } from '../shared/models';

export type FailedToSyncCropFields = FailedToSyncCropFieldItem[];

export interface FailedToSyncCropFieldItem {
  cropField: CropField;
  error: HttpErrorResponse;
  batchIndex: number;
}

export const CropFieldEvents = {
  syncCropFieldsReady: 'Agrifirm.ArableAdvice.SyncCropFieldsReady',
  fmsCropFieldSyncProtectedFieldsSkipped:
    'Agrifirm.ArableAdvice.FmsCropFieldSyncProtectedFieldsSkipped',
};

export interface FmsCropFieldSyncProtectedFieldsSkippedEvent {
  CustomerId: number;
  CropFieldId: number;
  CropFieldName: string;
  SkippedFields: string[];
}

export interface ProtectedFieldsSkippedGroup {
  cropFieldId: number;
  cropFieldName: string;
  skippedFields: string[];
}

export interface NextSalesPotentialDto {
  salesPotentialSeed: boolean;
  salesPotentialBem: boolean;
  salesPotentialGbm: boolean;
  isSkal: boolean;
  areaInHectares: number;
  cropId: number;
  customerId: number;
  id: number;
}
